module.exports = "<ui-form-element\n    [title]=\"title\"\n    [description]=\"description\"\n    [highlightPhrase]=\"highlightPhrase\">\n\n    <ui-text [format]=\"format\"\n             [requirements]=\"requirements\"\n             [id]=\"id\"\n             [name]=\"name\"\n             [disabled]=\"disabled\"\n             [prefix]=\"prefix\"\n             [(ngModel)]=\"innerValue\">\n    </ui-text>\n    <ng-content></ng-content>\n</ui-form-element>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/form-elements/fe-text/fe-text.html
// module id = 1082
// module chunks = 3